
import { Component, Ref, Vue } from 'nuxt-property-decorator'
import StylizedModal from './common/StylizedModal.vue'

@Component
export default class WebPlayerInfoModal extends Vue {
  @Ref('info-modal') public modal!: StylizedModal

  show() {
    this.modal.show()
  }
}
